import type { SVGProps } from 'react';
const SvgChevronEnd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.606 5.027a.85.85 0 0 0-.596.68.8.8 0 0 0 .08.493l.062.126L8.02 9.163l2.868 2.836-2.868 2.836-2.868 2.837-.062.125c-.197.4-.054.87.333 1.096.243.142.6.142.846 0 .067-.038.785-.738 3.101-3.023a322 322 0 0 0 3.109-3.09q.156-.191.236-.441c.03-.096.035-.14.035-.34s-.005-.245-.035-.34a1.3 1.3 0 0 0-.236-.442c-.052-.063-1.451-1.454-3.109-3.09-2.316-2.284-3.034-2.985-3.1-3.023a1 1 0 0 0-.188-.077 1.1 1.1 0 0 0-.476 0m6.24 0a.86.86 0 0 0-.593.68.8.8 0 0 0 .08.493l.062.126 2.868 2.837 2.869 2.836-2.869 2.836-2.868 2.837-.062.125a.83.83 0 0 0 .342 1.1.77.77 0 0 0 .456.098.7.7 0 0 0 .42-.13c.16-.106 6.145-6.028 6.244-6.178.139-.21.205-.432.205-.688s-.066-.478-.205-.689c-.054-.081-.75-.779-3.102-3.105-3.164-3.13-3.146-3.112-3.33-3.17a1.25 1.25 0 0 0-.517-.008"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronEnd;
